import {firebaseAnalytics} from './firebaseAdapter'

export const trackUserProp = (propObj: {[key: string]: string}) => {
  return firebaseAnalytics.setUserProperties(propObj)
}